import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { useUserContext } from '@fortem-monorepo/react-spa'

import { audit } from '@/ag-grid/columns/audit/col-def'

export const createOldDBColDefs = (ctx: ReturnType<typeof useUserContext>) => {
  const canEdit = ctx.hasPermissions((permissions) => ({ permissions: [permissions.WRITE_TRADES] }))

  return createColDefs([
    audit,
    {
      width: 125,
      field: 'blotterid',
      filter: false,
      cellStyle: {
        textAlign: 'center',
      },
    },
    {
      width: 125,
      field: 'fundname',
      editable: canEdit,
      cellStyle: {
        textAlign: 'center',
      },
    },
    {
      width: 225,
      field: 'productname',
      editable: canEdit,
    },
    {
      width: 150,
      field: 'notional',
      type: 'rightAligned',
      editable: canEdit,
      valueFormatter: numberFormatter({ delimiter: true }),
      cellClass: 'text-right',
    },
    {
      width: 150,
      field: 'price',
      type: 'rightAligned',
      editable: canEdit,
      valueFormatter: numberFormatter({
        delimiter: true,
        minimumFractionDigits: 6,
      }),
      cellClass: 'text-right',
    },
    {
      width: 135,
      field: 'tradedate',
      rowGroup: true,
      editable: canEdit,
      cellEditor: 'agDateStringCellEditor',
      cellStyle: {
        textAlign: 'center',
      },
    },
    {
      width: 135,
      field: 'settdate',
      editable: canEdit,
      cellStyle: {
        textAlign: 'center',
      },
    },
    {
      width: 150,
      field: 'tradetype',
      cellStyle: {
        textAlign: 'center',
      },
    },
    {
      width: 150,
      field: 'collatbucket',
      editable: canEdit,
      cellStyle: {
        textAlign: 'center',
      },
    },
    {
      width: 150,
      field: 'yieldlock',
      editable: canEdit,
      cellStyle: {
        textAlign: 'center',
      },
    },
  ])
}
